"use strict";

$(document).ready(function () {
  $(".doctor-bio-masthead__profile .save-physician").each(function () {
    var id = $(this).attr('data-physician-id');
    var value = localStorage.getItem('favorite-physicians');
    if (value !== null && value.includes(id)) {
      $(this).addClass('saved');
    }
  });
  $(".doctor-bio-masthead__profile .save-physician").click(function () {
    var id = $(this).attr('data-physician-id');
    if (id === undefined) return;
    var value = localStorage.getItem('favorite-physicians');
    var ids = null;
    if (value == null || value == '') {
      ids = id.split(',');
      $(this).addClass('saved');
    } else {
      ids = value.split(',');
      if (ids.includes(id)) {
        ids = ids.filter(function (e) {
          return e !== id;
        });
        $(this).removeClass('saved');
      } else {
        ids.push(id);
        $(this).addClass('saved');
      }
    }
    localStorage.setItem('favorite-physicians', ids.join(','));
  });
});